import React from 'react';
import ContentContainer from "../../components/ContentContainer";
import './contact.sass'
import SNSButtons from "../../components/SNSButtons";

function Contact() {
    return (
        <ContentContainer header={'Contact'}>
            <div className="contact">
                <p>Contact me for inquiries, personal websites, illustrations, designs, or for anything!</p>
                <a href="mailto: eureynoguchi@gmail.com" target="_blank" rel="noreferrer nofollow">
                  <p className="contact__email">eureynoguchi@gmail.com</p>
                </a>

                <div className="contact__sns">
                    <SNSButtons spacing={null} />
                </div>
                <p className="copyright">&copy; Eurey Noguchi 2022</p>
            </div>
        </ContentContainer>
    );
}

export default Contact;